import api from 'shared/api';
import { formatOrderBy } from 'shared/helpers';

export const getOrder = (orderID) => {
  const url = `/api/v1/orders/${orderID}/`;
  return api.get(url);
};

export const getOrderCore = (orderID) => getOrder(orderID);

export const getOrderLicenses = (orderID, options = {}) => {
  const { limit, offset, orderBy } = options;
  const limitQuery = Number.isInteger(limit) ? `&limit=${limit}` : '';
  const offsetQuery = Number.isInteger(offset) ? `&offset=${offset}` : '';
  const orderQuery = formatOrderBy(orderBy);
  const url = `/api/v1/licenses/?order_id=${orderID}&bundle_license__isnull=1${limitQuery}${offsetQuery}${orderQuery}`;
  return api.get(url);
};

export const patchOrder = (orderID, data) => {
  const url = `/api/v1/orders/${orderID}/`;
  return api.patch(url, data);
};

export const disableLicenses = (licenseIds) => {
  const url = '/api/v1/licenses/disable_bulk/';
  return api.post(url, licenseIds);
};

export const getOrderManagers = (orderID) => {
  const url = `/api/v1/orders/${orderID}/managers/`;
  return api.get(url);
};

export const addOrderManager = (orderID, data) => {
  const url = `/api/v1/orders/${orderID}/add_manager/`;
  return api.post(url, data);
};

export const removeOrderManager = (orderID, licenseUserID) => {
  const url = `/api/v1/orders/${orderID}/remove_manager/`;
  return api.post(url, { license_user_id: licenseUserID });
};

export const patchLicenseUser = (userId, data) => {
  const url = `/api/v1/users/${userId}/`;
  return api.patch(url, data);
};

export const setLicenseUserPassword = (userId, data) => {
  const url = `/api/v1/users/${userId}/set_password/`;
  return api.post(url, data);
};

export const checkExistingUser = (userEmail) => {
  const email = encodeURIComponent(userEmail);
  const url = `/api/v1/users/check_user_email?email=${email}`;
  return api.get(url);
};
